import { useState, useRef, useEffect } from "react";
import { Receiver } from "./Receiver";
import { GrRobot } from "react-icons/gr";
import { IoChatbubbleOutline } from "react-icons/io5";
import { MdPerson } from "react-icons/md";

export default function AssistantAgent() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, isLoading]);

  const handleSend = async () => {
    if (!input.trim() || isLoading) return;

    const userMsg = { role: "user", content: input };
    const updatedMessages = [...messages, userMsg];
    setMessages(updatedMessages);
    setInput("");
    setIsLoading(true);

    const reply = await Receiver(input, updatedMessages);
    setMessages(prev => [...prev, { role: "assistant", content: reply }]);
    setIsLoading(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <>
      {open && (
        <div className="chat-box">

          <div className="chat-header">
            <div className="chat-header-info">
              <div className="chat-avatar"><GrRobot/></div>
              <span>Kevin's Assistant</span>
            </div>
            <button onClick={() => setOpen(false)}>✕</button>
          </div>

          <div className="chat-body">
            {/* Greeting */}
            <div className="chat-greeting">
              <div className="msg-avatar ai"><GrRobot/></div>
              <div className="bubble">
                Hi! I'm Kevin's assistant. Feel free to ask me anything about Kevin!
              </div>
            </div>

            {/* Messages */}
            {messages.map((msg, i) => (
              <div key={i} className={`msg-row ${msg.role === "user" ? "user" : "ai"}`}>
                <div className={`msg-avatar ${msg.role === "user" ? "user-av" : "ai"}`}>
                  {msg.role === "user" ? <MdPerson/> : <GrRobot/>}
                </div>
                <div className="bubble">{msg.content}</div>
              </div>
            ))}

            {/* Typing indicator */}
            {isLoading && (
              <div className="msg-row ai">
                <div className="msg-avatar ai"><GrRobot/></div>
                <div className="typing-bubble">
                  <span className="dot" />
                  <span className="dot" />
                  <span className="dot" />
                </div>
              </div>
            )}

            <div ref={bottomRef} />
          </div>

          <div className="chat-input">
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Ask about Kevin..."
              disabled={isLoading}
            />
            <button onClick={handleSend} disabled={isLoading}>
              <svg className="send-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 21l21-9L2 3v7l15 2-15 2v7z"/>
              </svg>
            </button>
          </div>

        </div>
      )}

      <button className="chat-button" onClick={() => setOpen(!open)}>
        <IoChatbubbleOutline/>
      </button>
    </>
  );
}